import type { ReactElement } from 'react'

import { RelatedDocumentLinks } from '@features/invoices/elements/RelatedDocumentLinks'
import type { RelatedDocumentWithLink } from '@features/invoices/types/relatedDocument'
import { getTrackingDocumentType } from '@features/invoices/utils/getTrackingDocumentType'

import { useTrackInvoiceView } from '../../../../../../hooks/useTrackInvoiceView'
import { useInvoiceRelatedDocuments } from './hooks/useInvoiceRelatedDocuments'

export const InvoiceRelatedDocuments = (): ReactElement => {
  const relatedDocuments = useInvoiceRelatedDocuments()
  const { trackInvoiceView } = useTrackInvoiceView()

  const handleDocumentClick = (document: RelatedDocumentWithLink) => {
    trackInvoiceView('Related document clicked', {
      relatedDocumentType: getTrackingDocumentType({
        billingStage: document.billingStage,
        documentType: document.documentType,
      }),
    })
  }

  return <RelatedDocumentLinks onDocumentClick={handleDocumentClick} relatedDocuments={relatedDocuments} />
}
